import { cn } from "@/shared/libs/commonUtils";
import type { ComponentProps, ReactNode, Ref } from "react";
import { useCarousel } from "./CarouselContext";
import { Button } from "../button";
import PhosphorIcon from "../PhosphorIcon";

interface ICarouselNextProps extends ComponentProps<typeof Button> {
  ref?: Ref<HTMLButtonElement>;
  icon?: ReactNode;
}

export default function CarouselNext({
  ref,
  icon,
  className,
  variant = "outline",
  size = "icon",
  ...props
}: ICarouselNextProps) {
  const { orientation, scrollNext, canScrollNext } = useCarousel();
  return (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      className={cn(
        "absolute h-8 w-8 !rounded-full",
        orientation === "horizontal"
          ? "-right-12 top-1/2 -translate-y-1/2"
          : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
        className,
      )}
      disabled={!canScrollNext}
      onClick={scrollNext}
      {...props}
    >
      {icon || <PhosphorIcon name="CaretRight" size={20} />}
    </Button>
  );
}
